const formValidation = require('../components/formValidation');
const scrollAnimate = require('../components/scrollAnimate');

function successMessage($form, message) {
    $form.addClass(window.styleConstants.hideClass);
    $('.js-success-container').removeClass(window.styleConstants.hideClass);
    $('.js-success-message').html(message);

    scrollAnimate($('.js-success-container'));
}

$('.js-confirm-contact-us').on('submit', (e) => {
    e.preventDefault();

    const button = $('.js-confirm-contactus-button');
    const url = button.data('href');
    const $form = $(e.target);

    const $eventDay = $form.find('#eventDay');
    const $eventMonth = $form.find('#eventMonth');
    const $eventYear = $form.find('#eventYear');

    const $errorDate = $form.find('#preferred-event-date-error');

    function clearDateErrors() {
        $errorDate.text('').hide();
        $eventDay.removeClass('is-invalid');
        $eventMonth.removeClass('is-invalid');
        $eventYear.removeClass('is-invalid');
    }
    clearDateErrors();

    const dayVal = $eventDay.val();
    const monthVal = $eventMonth.val();
    const yearVal = $eventYear.val();

    let selectedCount = 0;
    if (dayVal && $.trim(dayVal) !== '') {
        selectedCount++;
    }
    if (monthVal && $.trim(monthVal) !== '') {
        selectedCount++;
    }
    if (yearVal && $.trim(yearVal) !== '') {
        selectedCount++;
    }

    if (selectedCount > 0 && selectedCount < 3) {
        const errorMessage = $eventMonth.data('parse-error');

        $errorDate.text(errorMessage).show();

        if (!dayVal || $.trim(dayVal) === '') {
            $eventDay.addClass('is-invalid');
        }

        if (!monthVal || $.trim(monthVal) === '') {
            $eventMonth.addClass('is-invalid');
        }

        if (!yearVal || $.trim(yearVal) === '') {
            $eventYear.addClass('is-invalid');
        }

        if (!monthVal || $.trim(monthVal) === '') {
            $eventMonth.focus();
        } else if (!dayVal || $.trim(dayVal) === '') {
            $eventDay.focus();
        } else if (!yearVal || $.trim(yearVal) === '') {
            $eventYear.focus();
        }

        return;
    }

    $form.spinner().start();

    $.ajax({
        url,
        type: 'post',
        dataType: 'json',
        data: $form.serialize(),
        success: (data) => {
            $form.spinner().stop();
            if (!data.success) {
                formValidation($form, data);
            } else {
                successMessage($form, data.msg);
            }
        },
        error: (err) => {
            if (err.responseJSON.redirectUrl) {
                window.location.href = err.responseJSON.redirectUrl;
            }
            $form.spinner().stop();
        }
    });
});

$('.js-event-date').on('change', function () {
    var $select = $('.js-event-date'),
        $month = $select.filter('.js-month'),
        $day = $select.filter('.js-day'),
        $year = $select.filter('.js-year'),
        month = parseInt($month.val()),
        day = parseInt($day.val()),
        currentDate = (new Date()),
        year = parseInt($year.val()),
        maxDaysFuture = $month.data('maxDaysFuture') || 365;

    const dayOptionTitleHtml = $day.find('option:first').html();
    const yearOptionTitleHtml = $year.find('option:first').html();

    if (!month) {
        return;
    }
    currentDate.setDate(1);
    currentDate.setMonth(month);
    currentDate.setDate(0);

    const dayOfMonth = currentDate.getDate();
    $day.children().remove();

    if (dayOptionTitleHtml) {
        $day.append($('<option>').val('').html(dayOptionTitleHtml).prop('selected', false));
    }
    for (var i = 1; i <= dayOfMonth; i++) {
        $day.append($('<option>').val(i).html(String(i)).prop('selected', day === i));
    }

    currentDate.setDate(1);
    currentDate.setMonth(month - 1);
    currentDate.setDate(day);

    if (currentDate.getTime() < new Date().getTime()) {
        currentDate.setFullYear(currentDate.getFullYear() + 1);
    }
    var minYear = currentDate.getFullYear();
    currentDate.setDate(currentDate.getDate() + maxDaysFuture);
    $year.children().remove();
    new Option(yearOptionTitleHtml, '', false);

    if (yearOptionTitleHtml) {
        $year.append($('<option>').val('').html(yearOptionTitleHtml).attr('selected', false));
    }
    $year.append($('<option>').val(minYear).html(String(minYear)).attr('selected', year === minYear));

    if (!day) {
        return;
    }
}).filter('.js-day').trigger('change');
